import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useReducer } from 'react';
import { defaultState } from './defaultState';
import { AppReducer } from './AppReducer';
export const AppContext = createContext({});
const useAppContext = () => {
    const context = useContext(AppContext);
    if (context === undefined) {
        throw new Error('useAppContext must be used within an AppContextProvider');
    }
    return context;
};
const AppContextProvider = ({ children, }) => {
    const [state, dispatch] = useReducer(AppReducer, defaultState);
    const value = { state, dispatch };
    return _jsx(AppContext.Provider, { value: value, children: children });
};
export { AppContextProvider, useAppContext };
